import { Component, OnInit } from '@angular/core';
import { FormGroup, FormBuilder, Validators } from '@angular/forms';


import { ApiService } from 'src/app/Services/api.service';
import { LoaderService } from 'src/app/Services/loader.service';

import { CommonServices } from '../../../../../Services/common.service';
import { ExcelExportService } from './../../../../../Services/excel.service';


@Component({
  selector: 'app-halt-reports',
  templateUrl: './halt-reports.component.html',
  styleUrls: ['./halt-reports.component.css']
})
export class HaltReportsComponent implements OnInit {

  public formFilters: any = FormGroup;

  public myDate = new Date();
  public maxDate: any;
  public objectKeys = Object.keys;
  public processedData: any = {};

  constructor(
    public fb: FormBuilder,
    public comService: CommonServices,
    public api: ApiService,
    public loader: LoaderService,
    public excel: ExcelExportService
  ) {
    this.maxDate = new Date(
      this.myDate.getFullYear(),
      this.myDate.getMonth(),
      this.myDate.getDate() - 1
    );
    this.getRegNos();
    this.getVehicleDetails();
  }
  public startDateError: boolean;
  public allVehDownload: boolean;
  public showTable: boolean;
  public tableData: any = [];
  public excelData: any = {};
  public vehicles: any;
  public selectedSingleVeh: any = '';
  public vehicleRegNos: any
  public cols = [
    { key: '#', display: '#' },
    { key: 'StartTime', display: 'Start time', headerConfig: { isDefault: true } },
    { key: 'EndTime', display: 'End time', headerConfig: { isDefault: true } },
    { key: 'Location', display: 'Location' },
    { key: 'HaltDuration', display: 'Halt duration', headerConfig: { isDefault: true } },
    // { key: "Distance", display: "Total Distance (in Km)" },

  ];
  public noDataFoundEnable: boolean = false;
  ngOnInit(): void {
    this.reactiveForm();

  }

  reactiveForm() {
    this.formFilters = this.fb.group({
      selectedVehicle: ['', Validators.required],
      sDate: ['', Validators.required],
      eDate: ['', Validators.required],
      speedLimit: [''],
      hours: [0, Validators.required],
      minutes: [5, Validators.required]

    }, {
      validator: [this.comService.formToDateValidation('sDate', 'eDate', 'selectedVehicle')]
    });
  }
  getRegNos() {

    this.api.getOrgVehicleRegNos({}).then((res: any) => {
      if (res.status == 'success') {
        this.vehicleRegNos = res.data;
      }
    }).catch((err) => {
      console.log(err);
    });
  }

  async getVehicleEncryptRegNo(regNo) {
    return new Promise((resolve, rejects) => {
      this.api.getVehicleRegNo({ vehRegNo: regNo }).then((res) => {
        if (res['status'] == 'success') resolve(res['data']);
        else rejects(res['data'])
      })
    })
  }

  getVehicleDetails() {

    const obj = {
      orgID: localStorage.orgID,//this.orgID == null ? this.storage.get('vendorID_orgID').orgID : this.orgID,
      vendorID: localStorage.vendorID //this.vendorID == null ? this.storage.get('vendorID_orgID').vendorID : this.vendorID,
    };
    this.api.transportManagerVehicleList(obj).then((res: any) => {
      if (res.status == 'success') {
        this.vehicles = res.data;
      }
    }).catch((err) => {
      console.log(err);
    });

  }

  async submitForm(obj) {
    try {
      this.startDateError = false;
      let formFilds = obj.formFilds;
      this.vehicles = obj.vehicles;
      // if (this.formFilters.valid) {
      this.selectedSingleVeh = '';
      this.allVehDownload = false;
      // this.showTable = true;
      this.processedData = {};
      this.excelData = {};
      this.tableData = [];
      this.showTable = false;
      this.noDataFoundEnable = false;
      this.loader.show();
      const vehicle = formFilds.selectedVehicle;
      const startDate = new Date(formFilds.sDate + '');
      //let endDate = new Date(new Date(new Date(formFilds.eDate).setHours(23, 59, 59)) + '');
      let endDate = new Date(new Date(new Date(formFilds.sDate).setHours(23, 59, 59)) + '');
      if (!endDate || isNaN(new Date(endDate).getTime())) {
        endDate=startDate
      } 
      const hh = formFilds.hours;
      const mm = formFilds.minutes;
      const arr: any[] = []
      const getDaysArray = function (start, end) {
        for (const dt = new Date(start); dt <= end; dt.setDate(dt.getDate() + 1)) {
          const date: Date = new Date(dt);
          arr.push(date.getFullYear() + '/' + pad(date.getMonth() + 1) + '/' + pad(date.getDate()));
        }
        return arr;
      };
      const pad = (num) => {
        return num > 9 ? num : '0' + num;
      };
      const start = startDate.getFullYear() + '/' + pad(startDate.getMonth() + 1) + '/' + pad(startDate.getDate());
      const end = endDate.getFullYear() + '/' + pad(endDate.getMonth() + 1) + '/' + pad(endDate.getDate()); //byrao
      const daylist: any = getDaysArray(new Date(start), new Date(end)); //by rao
      //const daylist: any = getDaysArray(new Date(start), new Date(start));
      // const vehicleList = await this.comService.vehicleToObject(this.vehicles, vehicle);

      // const vehLen = this.objectKeys(vehicleList);
      let vehLen = [];
      if (!Array.isArray(formFilds.selectedVehicle)) vehLen = [formFilds.selectedVehicle];
      else vehLen = formFilds.selectedVehicle;


      const checkCurrentDay = (date) => {
        var inputDate = new Date(date);
        // Get today's date
        var todaysDate = new Date();
        // call setHours to take the time out of the comparison
        if (inputDate.setHours(0, 0, 0, 0) == todaysDate.setHours(0, 0, 0, 0)) return true;
        else return false;
      };

      let vehRegString = '';
      for (let veh = 0; veh < vehLen.length; veh++) {
        if (vehLen[veh]) {
          if (vehRegString == '') vehRegString = vehLen[veh];
          else vehRegString = vehRegString + ',' + vehLen[veh];
        }
      }

      // let vehRegString = '';
      // for (let veh = 0; veh < vehLen.length; veh++) {
      //   vehRegString = vehRegString + ',' + vehLen[veh];
      // }

      let vehRegEncryKey = await this.getVehicleEncryptRegNo(vehLen).catch((e) => {
        this.noDataFoundEnable = true;
        })

      // let finalEncryKey = [];
      // for(let v=0;v < Object.keys(vehRegEncryKey).length;v++){
      //   let key = Object.keys(vehRegEncryKey)[v];
      //   if(vehRegEncryKey[key]!=undefined){
      //     finalEncryKey.push(vehRegEncryKey[key]+'.z');
      //   }
      // }
      // this.storage.setData({ vehiclePath: finalEncryKey });
      // this.shared._subject.next({
      //   type:'loaderToggle',
      //   data:{ loaderHide:true }
      // });

      // this.storage.setData({ loaderHide:true });
      for (let veh = 0; veh < vehLen.length; veh++) {

        let pdata: any = [], excel = [];
        if (vehLen[veh] != undefined) {
          if (this.processedData[vehLen[veh]] == undefined) { this.processedData[vehLen[veh]] = {}; }
          for (let day = 0; day < daylist.length; day++) {
            let checkDay = checkCurrentDay(daylist[day]);
            if (this.processedData[vehLen[veh]][daylist[day]] == undefined) this.processedData[vehLen[veh]][daylist[day]] = {};
            if (!checkDay) {
              this.loader.show();

              if (vehRegEncryKey[vehLen[veh]] != null) {
                const splitDate = daylist[day].split('/');
                const date = splitDate[2] + splitDate[1] + splitDate[0].slice(-2);
                const url = date + '/' + vehRegEncryKey[vehLen[veh]] + '.z';
                const res = await this.api.readS3Data(url).catch((e) => { });
                // console.log('@@@@---> ', res)
                if (JSON.stringify(res) != '{}' && res != undefined && res != null && res != '') {
                  if (this.processedData[vehLen[veh]][daylist[day]] == undefined) { this.processedData[vehLen[veh]][daylist[day]] = {}; }
                  let tempData: any = await this.processData(res, hh, mm);
                  excel = [...excel, ...tempData['xldata']];
                  pdata = [...pdata, ...tempData['data']];
                  // console.log('P data ', pdata.data.length, pdata);
                  this.loader.hide();
                } else {
                  let tempData: any = {
                    "data": [
                      {
                        "StartTime": this.comService.convertDateString(daylist[day]),
                        "EndTime": "---",
                        "Location": "---",
                        "HaltDuration": "---",
                      }
                    ],
                    "xldata": [
                      {
                        "value": [
                          this.comService.convertDateString(daylist[day]),
                          "---",
                          "---",
                          "---"
                        ]
                      }
                    ]
                  }

                  excel = [...excel, ...tempData['xldata']];

                  let resValue = {
                    "StartTime": this.comService.convertDateString(daylist[day]),
                    "EndTime": "---",
                    "Location": "---",
                    "HaltDuration": "---",
                  }
                  this.tableData.push(resValue)
                }
              }
            }
            else {
              this.loader.show();
              let obj = {
                vehRegNo: vehLen[veh],
                date: new Date().setHours(0, 0, 0)
              };
              if (this.processedData[vehLen[veh]][daylist[day]] == undefined) { this.processedData[vehLen[veh]][daylist[day]] = {}; }
              let getData = await this.comService.currentDayTrackingData(obj).catch((e) => { console.log('Unable to get current day data.'); });
              let tmpData: any = await this.processData(getData, hh, mm);
              excel = [...excel, ...tmpData['xldata']];
              pdata = [...pdata, ...tmpData['data']];
              this.loader.hide();
            }
            this.processedData[vehLen[veh]][daylist[day]] = pdata;
          }
          if (excel.length > 0) {
            let rowCount = 2;
            let endCell = 'E';
            let customizedData = [];
            let titleRow = {
              value: ['Halt Report'],
              font: {
                name: 'Corbel', family: 4, size: 16, bold: true,
                color: { argb: 'FFFFFFFF' },

              },
              mergeCells: `A${(rowCount - 1) + ''}:${endCell + rowCount + ''}`,
              alignment: {
                cell: `A${(rowCount - 1) + ''}`, value: { vertical: 'middle', horizontal: 'center' },
              },
              fill: {
                type: 'pattern',
                pattern: 'solid',
                fgColor: { argb: '966462AF' },
                bgColor: { argb: '966462AF' }
              },
            }

            customizedData.push(titleRow);

            rowCount = rowCount + 3;

            let subtitleRow = {
              value: [
                "Vehicle            : " + String(vehLen[veh]).toUpperCase() + "\n" +
                "Start Date       : " + this.comService.timestampToDate(new Date(startDate).getTime(), 'DMY') + "\n" +
                "End Date         : " + this.comService.timestampToDate(new Date(endDate).getTime(), 'DMY') + ""
              ],
              font: { name: 'Corbel', family: 4, size: 12, },
              mergeCells: `A${(rowCount - 2) + ''}:${endCell + rowCount + ''}`,
            }

            customizedData.push(subtitleRow);
            rowCount = rowCount + 1;
            let headerRow =
            {
              value: ['S No', 'Start time', 'End time', 'Location', 'Total duration'],
              fill: {
                type: 'pattern',
                pattern: 'solid',
                fgColor: { argb: 'FFFFFF00' },
                bgColor: { argb: 'FF0000FF' }
              },
              font: { bold: true },
              border: { top: { style: 'thin' }, left: { style: 'thin' }, bottom: { style: 'thin' }, right: { style: 'thin' } }
            }
            customizedData.push(headerRow);

            let sNo = 1;
            excel = excel.map((item) => {
              item['value'] = [sNo, ...item['value']];
              sNo++;
              return item;
            })

            customizedData.push(...excel);

            // const excelInfo = {
            //   title: {
            //     title: 'Halt Report',
            //     subTitleRow: 'Date : ' + this.comService.timestampToDate(new Date(startDate).getTime(), 'DMY H:M:S') + ' to ' + this.comService.timestampToDate(new Date(endDate).getTime(), 'DMY H:M:S') ,
            //     font: { name: 'Corbel', family: 4, size: 16, underline: 'double', bold: true },
            //     mergeCells: 'A1:E2',
            //   },
            //   header: {
            //     headers: ['S.No','Start Time', 'End Time', 'Location', 'Total Duration'],
            //     fill: {
            //       type: 'pattern',
            //       pattern: 'solid',
            //       fgColor: { argb: 'FFFFFF00' },
            //       bgColor: { argb: 'FF0000FF' }
            //     },
            //     border: { top: { style: 'thin' }, left: { style: 'thin' }, bottom: { style: 'thin' }, right: { style: 'thin' } }
            //   },
            //   data: {
            //     data: excel,
            //     columWith: [{ colNo: 1, width: 10 }, { colNo: 2, width: 20 }, { colNo: 3, width: 20 }, { colNo: 4, width: 70 },{ colNo: 5, width: 30 }]
            //   }
            // };

            if (this.excelData[vehLen[veh]] == undefined) { this.excelData[vehLen[veh]] = {}; }
            this.excelData[vehLen[veh]] = {
              customizedData: customizedData,
              data: {
                columWith: [{ colNo: 1, width: 10 }, { colNo: 2, width: 20 }, { colNo: 3, width: 20 }, { colNo: 4, width: 70 }, { colNo: 5, width: 30 }]

              }
            }; //excelInfo;
          }
        }
      }

      if (!vehLen.includes('ALL') && vehLen.length <= 1) {
        this.selectedSingleVeh = vehicle;
        this.tableData.sort(function (x, y) {
          return x.gpsts - y.gpsts;
        });
        this.showTable = true;
      } else { this.allVehDownload = true; }
      this.noDataFoundEnable = true;

      this.loader.hide();
      // } else {
      //   if (this.formFilters.errors && this.formFilters.errors.dates) {
      //     this.formFilters.controls.sDate.errors = this.formFilters.errors.dates;
      //     this.formFilters.controls.sDate.pristine = true;
      //     this.formFilters.controls.sDate.status = 'INVALID';
      //   }
      //   console.log(this.formFilters);
      // }
    } catch (error) {
      console.log(error);
    }
  }
  processData(data: any, hh: any, mm: any) {
    return new Promise((resolve, reject) => {
      try {
        const procesedData: any = [];
        const sortingData = {};
        if (data && data.length > 0) {
          data.map((item) => {
            item.date = this.comService.timestampToDate(item.gpsts, 'DMY H:M:S');
            if (item.gpsts != undefined) {
              sortingData[item.gpsts] = item;
            }
          });
        }
        else {
          this.noDataFoundEnable = true;
        }
        const chkObj = this.objectKeys(sortingData);
        if (chkObj && chkObj.length) {
          const ind = 1;
          const temp: any = {}, tempObj = [];
          const tempEx = [];
          let haltFlag = 0;
          let nextFlag = 0;
          let cnt = 0;
          // console.log('chkObj ',chkObj.length)
          for (let s = 0; s < chkObj.length; s++) {
            const currentKey = chkObj[s];

            const item = sortingData[currentKey];

            if (parseInt(item.spd) <= 5) {
              if (parseInt(item.spd) < 0) item.spd = 0;
              if (currentKey != undefined) {
                if (haltFlag == 0) {
                  cnt++;
                  haltFlag = 1;
                  if (temp[cnt] == undefined) { temp[cnt] = {}; }
                  temp[cnt].startTime = item.date;
                  temp[cnt].startTMS = item.gpsts;
                  temp[cnt].speed = item.spd;
                  temp[cnt].near = item.near;

                  if (nextFlag == 0) { nextFlag = 1; }
                }
              }
            } else {
              haltFlag = 0;
              if (nextFlag == 1) {
                temp[cnt].endTime = item.date;
                temp[cnt].endTMS = item.gpsts;
                nextFlag = 0;
              }
            }
            if (chkObj.length - 1 == s) {
              const haltProcessedData = [];
              const haltExData = [];
              for (const key in temp) {
                if (temp[key].endTMS != undefined && temp[key].endTMS != null && temp[key].endTMS != '') {
                  const haltTime = this.comService.timeDiff(Number(temp[key].startTMS), Number(temp[key].endTMS));
                  const processTMS = (new Date(this.comService.timestampToDate(temp[key].startTMS, 'MDY') + ' 00:00:00')).getTime() / 1000;
                  const sTime = this.comService.ts2str(temp[key].startTMS, processTMS);
                  const eTime = this.comService.ts2str(temp[key].endTMS, processTMS);
                  // if (hh != '' && mm != '') {
                  if ((parseFloat(haltTime.hh) >= parseFloat(hh)) && (parseFloat(haltTime.mm) <= (parseFloat(mm)))) {
                    const res = {
                      StartTime: this.comService.timestampToDate(temp[key].startTMS, 'DMY') + ' ' + sTime,
                      EndTime: this.comService.timestampToDate(temp[key].endTMS, 'DMY') + ' ' + eTime,
                      Location: String(temp[key].near).replace('\r', ''),
                      HaltDuration: haltTime.timeString,
                      ts: temp[key].gpsts
                    };
                    haltProcessedData.push(res);
                    this.tableData.push(res);
                    const resVal = {
                      value: [res.StartTime, res.EndTime, res.Location, res.HaltDuration]
                    };
                    haltExData.push(resVal);
                  }
                  // } else {
                  //   const res = {
                  //     StartTime: this.comService.timestampToDate(temp[key].startTMS, 'DMY') + ' ' + sTime,
                  //     EndTime: this.comService.timestampToDate(temp[key].endTMS, 'DMY') + ' ' + eTime,
                  //     Location: temp[key].near,
                  //     HaltDuration: haltTime.timeString,
                  //     ts: temp[key].gpsts
                  //   };
                  //   haltProcessedData.push(res);
                  //   this.tableData.push(res);
                  //   haltExData.push([sTime, eTime, haltTime.timeString, temp[key].near]);
                  //   // this.tableData.push(res);
                  // }
                }

              }
              resolve({ data: haltProcessedData, xldata: haltExData });
            }
          }

          //  resolve({data: temp,xlData:[]});
        } else {
          // console.log('empty', chkObj);
          resolve({ data: [], xldata: [] });
        }

      } catch (error) {
        console.log(error);
        reject(error);
      }
    });
  }

  async downloadAllVehicleHaltReport() {
    const chunk: any = await this.comService.chunkObject(this.excelData, 50);
    for (let i = 0; i < chunk.length; i++) {
      this.excel.generateExcel(chunk[i], 'Halt_Report_' + i + '_' + new Date().getTime() + '.xlsx');
    }

  }
  downloadHaltReport() {
    this.excel.generateExcel(this.excelData, 'Halt_Report_'+this.comService.timestampToDate(new Date().getTime(), 'DMY')  + '.xlsx');
  }

}
